module.exports = __webpack_public_path__ + "media/images/emblems/Oensingen-blason-0897047933c2db9013023dc815127bc2.png";